<template>
  <div class="home">
     <swiper ref="mySwiper" :options="swiperOptions">
      <swiper-slide><img src="../assets/home/banner.png" alt=""></swiper-slide>
	  <swiper-slide><img src="../assets/home/banner.png" alt=""></swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
  </div>
</template>

<script>
export default {
 	name: 'Home',
	data() {
    	return {
      		swiperOptions: {
				loop: true,
				autoplay: {
					delay: 1000,
					stopOnLastSlide: false,
					disableOnInteraction: true,
				},
				pagination: {
					el: '.swiper-pagination'
				},
        		// Some Swiper option/callback...
      		}
    	}
  	},
  
}
</script>

<style lang="scss" scoped>
.home {
  .banner{

  }
}
</style>
